import allCases from '../../fields/cases/allCases';

export const QUERY_GET_ALL_MD_CASES = /* GraphQL */ `
	query($limit: Float, $offset: Float, $filter: MietendeckelCaseFilter, $notEqual: MietendeckelCaseFilter) {
		getAllMietendeckelCase(
			limit: $limit
			offset: $offset
			filter: $filter
			notEqual: $notEqual
		) {
			items {
				${allCases}
			}
			total
		}
	}
`;
